import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/sub-admin";

export const List = async (values) => axiosInstance(options).post(`${path}/list`, values);
export const Add = async (values) => axiosInstance(options).post(`${path}/create`, values);
export const Edit = async (values) => axiosInstance(options).put(`${path}/update`, values);
export const Delete = async (values) => axiosInstance(options).delete(`${path}/delete`, { data: values });
export const Details = async (id) => axiosInstance(options).get(`${path}/details?o_id=${id}`);
export const Status = async (values) => axiosInstance(options).post(`${path}/change-status`, values);
export const RoleOptions = async () => axiosInstance(options).get(`${path}/role-options`);
